export const CONTEXT_LISTING = 1;
export const CONTEXT_B2B = 2;
export const CONTEXT_SHARED = 3;
